import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class ProductionTimeNorm implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fFactory: string,
    private fProduct: string,
    private fDays: number
  ) {
    [fId, fFactory, fProduct, fDays].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id() {
    return this.fId;
  }

  get factory(): string {
    return this.fFactory;
  }

  get product(): string {
    return this.fProduct;
  }

  get days(): number {
    return this.fDays;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
